/**
 * 加载js
 */
function loadScript(url, async = false) {
  const element = document.createElement('script');
  element.setAttribute('type', 'text/javascript');
  element.src = url;
  element.async = async;
  return new Promise((resolve, reject) => {
    document.head.appendChild(element);
    if (element.readyState) {
      element.onreadystatechange = () => {
        if (element.readyState === 'loaded' || element.readyState === 'complete') {
          element.onreadystatechange = null;
          resolve();
        }
      };
      element.onerror = reject;
    } else {
      element.onload = resolve;
      element.onerror = reject;
    }
  });
}

export default loadScript;
